import { useMemo } from 'react';
import { useSelectedItems } from '../../utils/use-context';

export const useTargetItemIds = (itemId: string) => {
  const { selectedItems } = useSelectedItems();

  return useMemo(() => {
    if (selectedItems.length > 1 && selectedItems.includes(itemId)) {
      return selectedItems;
    }

    return [itemId];
  }, [selectedItems, itemId]);
};
